import * as types from 'constants/actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {

    case types.RECEIVE_SHOPIFY_PLANS:
      return {
        ...state,
        plans: action.plans
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shopifyPlans.js